<template>
  <div class="operational-dashboard-bar">
    <span
      class="operational-dashboard-bar__dot"
      :style="{ backgroundColor: color }"
    />
    <span class="operational-dashboard-bar__label">{{ label }}</span>
    <span class="operational-dashboard-bar__track">
      <span
        class="operational-dashboard-bar__fill"
        :style="{ width: `${percentage}%`, backgroundColor: color }"
      />
    </span>
    <span class="operational-dashboard-bar__value">
      {{ count }} ({{ percentage }}%)
    </span>
  </div>
</template>

<script>
export default {
  name: 'HorizontalBar',
  props: {
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '#2F80ED',
    },
  },
  computed: {
    percentage() {
      if (!this.total) return 0;
      return Math.round((this.count / this.total) * 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.operational-dashboard-bar {
  align-items: center;
  display: flex;
  gap: var(--space-normal);
  padding: var(--space-slab) 0;

  &__dot {
    border-radius: var(--border-radius-rounded);
    flex-shrink: 0;
    height: 1rem;
    width: 1rem;
  }

  &__label {
    color: var(--s-800);
    flex-shrink: 0;
    font-size: var(--font-size-default);
    min-width: 10rem;
  }

  &__track {
    background: var(--s-100);
    border-radius: var(--border-radius-normal);
    flex: 1;
    height: 1.6rem;
    min-width: 0;
    overflow: hidden;
  }

  &__fill {
    border-radius: var(--border-radius-normal);
    display: block;
    height: 100%;
    min-width: 0;
    transition: width 0.2s ease-in-out;
  }

  &__value {
    color: var(--s-700);
    flex-shrink: 0;
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-medium);
    min-width: 7rem;
    text-align: right;
    white-space: nowrap;
  }
}
</style>
